// JavaScript Document
// Version: 2.0.0

var remove_option_code        = minerva_configurator_vars.remove_option_code;
var not_available_option_code = minerva_configurator_vars.not_available_option_code;
// Nel caso siano state create più finiture fittizie per lo stesso modello di penna, non potendo avere lo stesso codice XXX, viene utilizzata la wildcard XX*.
// Questo significa che per identificare una superficie fittizia si deve cercare la sequenza XX all'interno del relativo codice.
var dummy_surface_code        = remove_option_code.substr(0, remove_option_code.length -1);
var deferredET3;
var undoSelectedColors        = {};
var deferredET3Output         = {};
var pms_code                  = minerva_configurator_vars.pms_code;
var matches                   = minerva_configurator_vars.matches;
var constraints               = minerva_configurator_vars.constraints;
var exceptionsType1           = minerva_configurator_vars.exceptions_type1;
var exceptionsType2           = minerva_configurator_vars.exceptions_type2;
var exceptionsType3           = minerva_configurator_vars.exceptions_type3;
var exceptionsType4           = minerva_configurator_vars.exceptions_type4;
var exceptionsType5           = minerva_configurator_vars.exceptions_type5;



jQuery(document).ready(function($) {
    /**
	 * Gestisce il cambiamento di colore/superficie di un componente.
	 *
	 * @since 1.0.0
	 */
	$('body').on('click', '.surface-container .colors-list .color-item', function(e) {
		var that             = jQuery(this);
		var componentCtx     = getComponentCtx(that);
		var activeSurfaceCtx = getActiveSurfaceCtx(componentCtx);
		var activeColorCtx   = getActiveColorCtx(activeSurfaceCtx);
		var activePaletteCtx = getColorPaletteCtx(activeColorCtx);

		saveSelectedColor(componentCtx.attr('id'),
			activeSurfaceCtx.data('surface-id'),
			activeSurfaceCtx.data('surface-code'),
			activePaletteCtx.data('palette-id'),
			activeColorCtx.attr('data-asset-color-code'),
			activeColorCtx.attr('data-alternative-color'));

		resetActiveColor(componentCtx);

		var surfaceCtx  = getSurfaceCtx(that);
		var surfaceCode = surfaceCtx.data('surface-code');
		var colorCtx    = that;

		setActiveColor(that);

		var colorCode           = colorCtx.attr('data-asset-color-code');
		var alternativeColor    = colorCtx.attr('data-alternative-color');
		var componentType       = colorCtx.data('component-type');
		var componentId         = colorCtx.data('component-id');

		var primaryComponentCtx = getPrimaryComponentCtx();
		var primarySurfaceCtx   = getActiveSurfaceCtx(primaryComponentCtx);
		var primarySurfaceCode  = primarySurfaceCtx.data('surface-code');


        // EXCEPTION TYPE 3
        // Per un dato codice colore è possibile definire un'azione alternativa da eseguire quando selezionato.
        // Una di queste azioni alternative è la selezione dei colori Pantone: in questo caso è necessario eseguire determinate operazioni prima di proseguire con l'esecuzione standard del codice, per questo è necessario l'utilizzo di jQuery.Deferred().
        jQuery.when(ET3(colorCtx)).done(function() {
            if ( !$.isEmptyObject(deferredET3Output) ) {
                surfaceCode      = deferredET3Output.surfaceCode;
                colorCode        = deferredET3Output.colorCode;
                alternativeColor = deferredET3Output.alternativeColor;
            }

            if ( componentType == 'primary' ) {
                updateComponentsSurfaces(surfaceCode, colorCode, alternativeColor);
            }

           // EXCEPTION TYPE 1
            // Per specifiche superfici di un dato componente (master) è possibile definire quali superfici di un altro componente (slave) mostrare.
			var masterComponents = $.map(exceptionsType1, function(value, key) {
				return parseInt(key);
			});

            if ( componentType == 'primary' || $.inArray(componentId, masterComponents) > -1 ) {
                ET1(false, colorCtx);
            }


            // EXCEPTION TYPE 2
            // Per specifiche superfici di un dato componente (master) è possibile definire per quali superfici di un altro componente (slave) è abilitato il mix & match.
            // E' possibile impostare un messaggio di avviso.
           	masterComponents = $.map(exceptionsType2, function(value, key) {
				return parseInt(key);
			});

            if ( componentType == 'primary' || $.inArray(componentId, masterComponents) > -1 ) {
                ET2(false, colorCtx);
            }


			// EXCEPTION TYPE 4
            // Per specifiche superfici di un dato componente (master) è possibile eseguire una funzione.
			// E' possibile passare alla funzione una serie di argomenti, la cui struttura potrà variare a seconda della funzione.
			// Es. selezionando il nose code metallico vengono spostare le arre di stampa sul boby.
            masterComponents = $.map(exceptionsType4, function(value, key) {
				return parseInt(key);
			});

            if ( $.inArray(componentId, masterComponents) > -1 ) {
                ET4();
            }


			removeOptionHandler();
			reorderComponentsOptions();
            writingSystemAdvancedSettings(componentId, surfaceCode);
			updateComponentPrintAreas(componentId, surfaceCode, primarySurfaceCode);

			var otherComponentsCtx = getComponentCtxByDataAttribute([
				{
					dataAttribute: 'component-id',
					attributeValue: componentId,
					dataRelation: '!='
				},
				{
					dataAttribute: 'component-type',
					attributeValue: 'primary',
					dataRelation: '!='
				}
			]);

            otherComponentsCtx.each(function(index, element) {
                var otherComponentCtx = $(element);
                var otherComponentId  = otherComponentCtx.data('component-id');
				var otherSurfaceCtx   = getActiveSurfaceCtx(otherComponentCtx);
                var otherSurfaceCode  = otherSurfaceCtx.data('surface-code');

                updateComponentPrintAreas(otherComponentId, otherSurfaceCode, primarySurfaceCode);
            });

			updatePrintAreasCompleted();
            updateTextColorPalette();
			updateQRCodes(); // @since 2.0.0
			refreshPreview();
			updateConfigurationRecap();
			closeActivePanel(componentCtx);
        });

	});



	/**
	 * Gestisce il cambiamento del sistema di scrittura.
	 *
	 * @since 1.0.0
	 */
	$('body').on('change', 'input[name="refill"]', function(e) {
		updateWritingSystemOptions();
		refreshPreview();
		updateConfigurationRecap();
	});



	/**
	 * Gestisce il cambiamento di colore dell'inchiostro.
	 *
	 * @since 1.0.0
	 */
	$('body').on('click', '.ink-colors-list li', function(e) {
		var that = $(this);
		var ctx  = getInkColorCtx(that);

		getActiveInkColorCtx(ctx).removeClass('active');
		that.addClass('active');
		updateWritingSystemOptions();
		updateConfigurationRecap();
	});



	/**
	 * Gestisce il cambiamento del diametro del refill.
	 *
	 * @since 1.0.0
	 */
	$('body').on('change', 'input[name^="diameter-"]', function(e) {
		updateConfigurationRecap();
	});



	/**
	 * Gestisce il cambiamento di colore del refill.
	 *
	 * @since 1.0.0
	 */
	$('body').on('click', '.refill-colors-list li', function(e) {
		var that = $(this);
		var ctx  = getRefillColorCtx(that);

		getActiveRefillColorCtx(ctx).removeClass('active');
		that.addClass('active');
		refreshPreview();
		updateConfigurationRecap();
	});



    /**
     * Gestione dello switch "Remove option".
     *
     * @since 1.1.0
     */
	$('body').on('change', '.remove-option-switch', function(e) {
		var that         = $(this);
		var surfaceCtx   = getSurfaceCtx(that);
		var componentCtx = getComponentCtx(that);
		var surfacesCtx  = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'surface-code',
				attributeValue: 'XXX',
				dataRelation: '!='
			}
		], false, componentCtx);

		if ( that.prop('checked') && !surfaceCtx.hasClass('active') ) {
			$(getColorCtx(surfaceCtx)[0]).trigger('click');
		}

		if ( !that.prop('checked') ) {
			surfacesCtx.removeClass('disabled');
		} else {
			jQuery.each(surfacesCtx, function(index, element) {
				if (!jQuery(element).hasClass('not-available-surface')) {
					jQuery(element).addClass('disabled');
				}
			});
		}
	});



    /**
	 * Mostra l'overlay all'apertura dei pannelli relativi ai componenti.
	 *
	 * @since 1.1.0
	 */
	$('.component-options-backdrop').on('click', function() {
		var panel = getActiveComponentCtx();

		closeActivePanel(panel);
	});



	/**
	 * Gestisce la chiusura del pannello relativo ad un componente.
	 *
	 * @since 1.1.0
	 */
	$('.component-options .close-panel').on('click', function() {
		closeActivePanel();
	});



	/**
	 * Gestisce la selezione di un selettore di un componente.
	 *
	 * @since 1.1.0
	 */
	$('button.component-selector').on('click', function() {
		var componentSelector = $(this);

		if ( !componentSelector.hasClass('disabled') && !componentSelector.hasClass('active') ) {
			openPanel(componentSelector);
		} else if ( componentSelector.hasClass('active') ) {
			closeActivePanel();
		} else {
			closeActivePanel();
			openPanel(componentSelector);
		}
	});



	/**
	 * Gestisce l'effetto hover sul selettore di un componente.
	 *
	 * @since 1.1.0
	 */
	$('.config-controls button.component-selector').hover(
		function() {
			if ( !$(this).hasClass('disabled') ) {
				$('.config-controls button.component-selector[data-component-id!="' + $(this).data('component-id') + '"]').addClass('disabled');
			}
		}, function() {
			if ( !$(this).hasClass('active') && !$(this).hasClass('disabled') ) {
				$('.config-controls button.component-selector[data-component-id!="' + $(this).data('component-id') + '"]').removeClass('disabled');
			}
		}
	);



    /* DA RIVEDERE */
	/**
     * Gestione della Palette Pantone.
     *
     * @since 1.0.0
     */
    $('#pms #search').hideseek();

    $('#pms').on('show.bs.modal', function (e) {
        $('.pms-list li.active').removeClass('active');

		var panelWrapper       = $('.tab-pane-c.active');
		var panelWrapperId     = panelWrapper.attr('id');
		var colorCode          = undoSelectedColors[panelWrapperId].colorCode;
		var surfaceCode        = undoSelectedColors[panelWrapperId].surfaceCode;
		var currentSurfaceCode = $('.tab-pane-c.active .surface-item.active').data('surface-code');
		var currentColorCode   = $('.tab-pane-c.active .surface-item.active .colors-list li.active .selection span').attr('data-asset-color-code');

		if (currentColorCode != pms_code) {
			$('.pms-list li .selection span[data-asset-color-code="' + currentColorCode + '"]').closest('li').addClass('active');
		}
    });

    $('body').on('click', 'ul.pms-list li', function(e) {
        // "dataObj" è un oggetto JSON con i dati del colore, superficie, componente selezionato.
        var dataObj          = JSON.parse($('#pms').attr('data-object'));
        var panelWrapperId   = dataObj.panelWrapperId;
        var surfaceWrapperId = dataObj.surfaceWrapperId;
        var colorsWrapperId  = dataObj.colorsWrapperId;
        var colorCode        = dataObj.colorCode;

        var panelWrapper     = $('.tab-pane-c[id="' + panelWrapperId + '"]');
        var surfaceWrapper   = $('.surface-item[data-surface-id="' + surfaceWrapperId + '"]', panelWrapper);
        var colorsWrapper    = $('.colors-list[data-palette-id="' + colorsWrapperId + '"]', surfaceWrapper);
        var selectedColor    = $('span[data-asset-color-code="' + colorCode + '"]', colorsWrapper).closest('li');

        var that             = $(this);
        var PMScolorCode     = $('.selection span', that).attr('data-asset-color-code');
        // Il tooltip di Bootstrap sposta il contenuto dell'attributo "title" nell'attributo "data-original-title".
        var PMScolorLabel    = $('.selection span', that).attr('data-original-title');
        var PMScolor         = $('.selection span', that).css('background-color');

        $('.pms-list li.active').removeClass('active');
        that.addClass('active');

		// Aggiorno il bottone Pantone della superficie/palette selezionata con i dati del colore Pantone selezionato.
        $('.selection span', selectedColor).attr('data-asset-color-code', PMScolorCode);
        $('.selection span', selectedColor).attr('title', PMScolorLabel).attr('data-original-title', PMScolorLabel);
        $('.selection span', selectedColor).css('background-color', PMScolor);
        selectedColor.removeClass('btn-pms');

        deferredET3Output    = {
            surfaceCode: surfaceWrapper.attr('data-surface-code'),
            color: PMScolorCode,
            alternativeColor: $('.selection span', selectedColor).attr('data-alternative-color'),
        };

        $('#pms').modal('hide');
    });

    $('#pms').on('hide.bs.modal', function (e) {
        if ( $('.pms-list li.active').length == 0 ) {
            // Devo rispristinare il colore precedentemente selezionato.
            var panelWrapper     = $('.tab-pane-c.active');
            var panelWrapperId   = panelWrapper.attr('id');
            var surfaceWrapperId = undoSelectedColors[panelWrapperId].surfaceWrapperId;
            var surfaceWrapper   = $('.surface-item[data-surface-id="' + surfaceWrapperId + '"]', panelWrapper);

            $('.colors-list li.active', panelWrapper).removeClass('active');
            $('.surface-item.active', panelWrapper).removeClass('active');
            surfaceWrapper.addClass('active');

            var colorsWrapperId  = undoSelectedColors[panelWrapperId].colorsWrapperId;
            var colorsWrapper    = $('.colors-list[data-palette-id="' + colorsWrapperId + '"]', surfaceWrapper);
            var colorCode        = undoSelectedColors[panelWrapperId].colorCode;

            $('[data-asset-color-code="' + colorCode + '"]', colorsWrapper).closest('li').addClass('active');
            deferredET3Output    = {
                surfaceCode: undoSelectedColors[panelWrapperId].surfaceCode,
                color: undoSelectedColors[panelWrapperId].colorCode,
                alternativeColor: undoSelectedColors[panelWrapperId].alternativeColorCode,
            };
        } else {
			$('.pms-list li.active').removeClass('active');
		}
    });

    $('#pms').on('hidden.bs.modal', function (e) {
        deferredET3.resolve();
    });



});



/**
 * Gestisce la compatibilità tra le finiture dei diversi componenti della penna.
 * L'oggetto "matches" ha la seguente struttura:
 *     matches = {
 *          "F":{
 *               "249":["F"],
 *               "250":["F"],
 *               "252":["F","S"],
 *               "255":["XXX","P"],
 *          },
 *          "T":{
 *               "249":["T"],
 *               "250":["T"],
 *               "252":["T","C"],
 *               "255":["XXX","P"],
 *          }
 *			...
 *     }
 *
 * @param {string} surfaceCode      : codice della superficie
 * @param {string} colorCode        : codice del colore
 * @param {string} alternativeColor : colore/i alternativo/i
 *
 * @since 1.0.0
 */
function updateComponentsSurfaces(surfaceCode, colorCode, alternativeColor) {
	// "alternativeColor" può essere:
	//    - un singolo codice colore
	//    - un elenco di codici colore separati da virgole
	//    - una coppia {componentSlug}|{colorCode}
	//    - un elenco di coppie {componentSlug}|{colorCode} separate da virgole
	var alternativeColors = ( is_defined(alternativeColor) && alternativeColor != '' ) ? alternativeColor.split(',') : [];
	var componentsCtx     = getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-type',
			attributeValue: 'primary',
			dataRelation: '!='
		}
	]);

	componentsCtx.each(function(cmpIndex, cmpElement) {
		var componentCtx      = jQuery(cmpElement);
		var componentType     = componentCtx.data('component-type');
		var componentId       = componentCtx.data('component-id');
		var componentSlug     = componentCtx.data('component-slug');

		// matches[surfaceCode] equivale a matches["F"] = { "249": ["F"], "250": ["F"], "252": ["F","S"], "255": ["0","P"] }
		// matches[surfaceCode][componentId] equivale a matches["F"]["252"] = ["F","S"]
		var surfaceCodes      = matches[surfaceCode][componentId];
		var componentSurfaces = getComponentSurfacesCtx(componentCtx);

		componentSurfaces.each(function(srfIndex, srfElement) {
			var surfaceCtx = jQuery(srfElement);

			checkSurfaceCompatibility(surfaceCodes, componentCtx, surfaceCtx);
		});

		if ( 'optional' != componentType ) {
			resetActiveColor(componentCtx);
			setNewColor(colorCode, alternativeColors, componentCtx, null);

			jQuery('.color-message p[data-asset-color-code!="' + colorCode + '"]', componentCtx).removeClass('active');
			jQuery('.color-message p[data-asset-color-code="' + colorCode + '"]', componentCtx).addClass('active');
		} else {

			// Se la superficie attiva non è più disponibile, imposto il colore alternativo o attivo la superficie "Remove option" o "Not available".
			if ( getActiveSurfaceCtx(componentCtx).attr('data-visible') == 'false' ) {
				resetActiveColor(componentCtx);
				setOptionalNewColor(alternativeColors, componentCtx);
			}
		}

		MixAndMatch(surfaceCode, componentCtx);

		showColorLegend(componentCtx);
	});
}



/**
 * Verifica la compatibilità della superficie con quella selezionata per un componente (normalmente quello principale).
 *
 * @param  {array}    surfaceCodes : codici superficie compatibili con il componente principale
 * @param  {selector} componentCtx : contesto componente
 * @param  {selector} surfaceCtx   : contesto superficie
 *
 * @return {bool}
 *
 * @since 1.1.0
 */
function checkSurfaceCompatibility(surfaceCodes, componentCtx, surfaceCtx) {
	var componentType      = componentCtx.data('component-type');
	var currentSurfaceCode = surfaceCtx.data('surface-code');
	var variantCtx         = surfaceCtx.closest('.variant-item');
	var surfaceWrapperCtx  = surfaceCtx.closest('.surface-wrapper');

	if ( surfaceCodes.indexOf(currentSurfaceCode.toString()) >= 0 ) {
		surfaceCtx.attr('data-visible', 'true').show();
		surfaceWrapperCtx.show();
	} else {
		if ( variantCtx.length > 0 ) {
			var visibleSurfaces = getSurfaceCtxByDataAttribute([
				{
					dataAttribute: 'visible',
					attributeValue: 'true',
					dataRelation: '='
				}
			], false, variantCtx);

			if ( 0 == visibleSurfaces.length ) {
				surfaceWrapperCtx.hide();
			}
		} else {
			surfaceWrapperCtx.hide();
		}

		surfaceCtx.attr('data-visible', 'false').hide();
	}
}



/**
 * Effettua il reset della superficie e del colore attivi.
 *
 * @param {selector} componentCtx : contesto componente
 *
 * @since 1.1.0
 */
function resetActiveColor(componentCtx) {
	getActiveColorCtx(componentCtx).removeClass('active');
	getActiveSurfaceCtx(componentCtx).removeClass('active');
}



/**
 * Attiva colore e la relativa superficie.
 *
 * @param {selector} colorCtx : contesto colore
 *
 * @since 1.1.0
 */
function setActiveColor(colorCtx) {
	if ( colorCtx.length > 1 ) {
		// colorCtx = jQuery(colorCtx[0]);

		colorCtx.each(function(index, element) {
			var surfaceContainer = jQuery(element).closest('.surface-container');

			if ( surfaceContainer.data('visible') ) {
				colorCtx = jQuery(colorCtx[index]);

				return false;
			}
		});
	}

	var componentCtx = getComponentCtx(colorCtx);

	resetActiveColor(componentCtx);
	colorCtx.addClass('active');
	getSurfaceCtx(colorCtx).addClass('active');
}



/**
 * Imposta il nuovo colore.
 *
 * @param {string}   colorCode         : codice colore del componente principale
 * @param {array}    alternativeColors : colori alternativi
 * @param {selector} componentCtx      : contesto componente
 * @param {selector} surfaceCtx        : contesto superficie
 *
 * @since 1.1.0
 */
function setNewColor(colorCode, alternativeColors, componentCtx, surfaceCtx) {
	var componentSlug = componentCtx.data('component-slug');
	var colorCtx      = getColorCtxByDataAttribute([
		{
			dataAttribute: 'asset-color-code',
			attributeValue: colorCode,
			dataRelation: '='
		}
	], componentCtx);

	if ( colorCtx.length > 0 ) {
		setActiveColor(colorCtx);
	} else {
		setAlternativeColor(alternativeColors, componentCtx, null);
	}
}



/**
 * Imposta il nuovo colore per i componenti opzionali.
 * Nella maggioranza dei casi il risultato è l'attivazione della superficie "Remove option" o "Not available".
 *
 * @param {array}    alternativeColors : colori alternativi
 * @param {selector} componentCtx      : contesto componente
 *
 * @since 1.1.0
 */
function setOptionalNewColor(alternativeColors, componentCtx) {
	var surfaceCtx;

	setAlternativeColor(alternativeColors, componentCtx, null);

	surfaceCtx = getSurfaceCtxByDataAttribute([
		{
			dataAttribute: 'visible',
			attributeValue: 'true',
			dataRelation: '='
		}
	], true, componentCtx);

	if ( surfaceCtx.length == 0 ) {
		var colorCtx = getColorCtxByDataAttribute([
			{
				dataAttribute: 'color-code',
				attributeValue: dummy_surface_code,
				dataRelation: '^='
			}
		], componentCtx);

		colorCtx.each(function(index, element) {
			surfaceCtx = getSurfaceCtx(element);

			if ( 'true' == surfaceCtx.attr('data-visible') ) {
				setActiveColor(jQuery(element));

				return false;
			}
		});
	}
}



/**
 * Imposta il colore alternativo.
 *
 * @param {array}    alternativeColors : colori alternativi
 * @param {selector} componentCtx      : contesto componente
 * @param {selector} surfaceCtx        : contesto superficie
 *
 * @since 1.1.0
 */
function setAlternativeColor(alternativeColors, componentCtx, surfaceCtx) {
	var componentSlug = componentCtx.data('component-slug');
	var condition;

	if ( alternativeColors.length > 0 ) {
		jQuery.each(alternativeColors, function(index, value) {
			var refColorCode;

			if ( value.indexOf('|') > -1 ) {
				var refComponentSlug = value.split('|')[0];
				refColorCode         = value.split('|')[1];

				if ( componentSlug != refComponentSlug ) {
					return;
				}
			} else {
				refColorCode = value;
			}

			if ( refColorCode.indexOf('_') > -1 ) {
				// Sono in presenza di un colore pantone.
				// Il codice colore alternativo è generico ed è del tipo "{surfaceCode}_PMS".
				// Il codice colore "ricevente" non è a priori noto, potrebbe essere generico (PMS) oppure specifico (PMS-102-C), quindi devo controllare la presenza della stringa "PMS".

				if ( null == surfaceCtx ) {
					surfaceCtx = getSurfaceCtxByDataAttribute([
						{
							dataAttribute: 'surface-code',
							attributeValue: refColorCode.split('_')[0],
							dataRelation: '='
						}
					], false, componentCtx);
					condition  = (surfaceCtx.length > 0);
				} else {
					condition  = (refColorCode.split('_')[0] == surfaceCtx.data('surface-code').toString());
				}

				if ( condition ) {
					surfaceCtx.addClass('active');
					getColorCtxByDataAttribute([
						{
							dataAttribute: 'asset-color-code',
							attributeValue: refColorCode.split('_')[1],
							dataRelation: '*='
						}
					], surfaceCtx).addClass('active');

					var primaryComponentCtx = getPrimaryComponentCtx();
					var primaryColorCtx     = getActiveColorCtx(primaryComponentCtx);

					getActiveColorCtx(surfaceCtx).attr('data-asset-color-code', primaryColorCtx.attr('data-asset-color-code')).attr('data-original-title', primaryColorCtx.attr('data-original-title')).css('background-color', primaryColorCtx.css('background-color')).removeClass('btn-pms');

					return false;
				}
			} else {
				var colorCtx = getColorCtxByDataAttribute([
					{
						dataAttribute: 'asset-color-code',
						attributeValue: refColorCode,
						dataRelation: '='
					}
				], componentCtx);

				if ( colorCtx.length > 0 ) {
					setActiveColor(colorCtx);

					return false;
				}
			}
		});
	} else {
		// do nothing.
	}

}



/**
 * Mostra la legenda relativa ai colori dei componenti.
 *
 * @param {selector} componentCtx : contesto componente
 *
 * @since 1.1.0
 */
function showColorLegend(componentCtx) {
	var surfacesCtx = getSurfaceCtxByDataAttribute([
		{
			dataAttribute: 'visible',
			attributeValue: 'true',
			dataRelation: '='
		}
	], false, componentCtx);
	var showLegend  = false;

	surfacesCtx.each(function(srfIndex, srfElement) {
		var surfaceCtx = jQuery(srfElement);
		var colorsCtx  = getColorCtx(surfaceCtx);
		var flag       = true;

		colorsCtx.each(function(clrIndex, clrElement) {
			if ( jQuery(clrElement).hasClass('novelty') ) {
				showLegend = true;
				flag       = false;

				return false;
			}
		});

		return flag;
	});

	if ( showLegend ) {
		jQuery('.color-legend', componentCtx).show();
	} else {
		jQuery('.color-legend', componentCtx).hide();
	}
}



/**
 * Gestisce i vincoli sui colori tra i diversi componeti della penna.
 * ATTENZIONE a come la presenza o meno di un vincolo viene gestita lato backend:
 *    - la stringa "mm" nella variabile "constraints" significa che il componente NON supporta il mix & match
 *
 * L'oggetto "constraints" ha la seguente struttura:
 *     constraints = {
 *          "F":{
 *               "249":"",
 *               "250":"",
 *               "252":"",
 *               "255":"",
 *          },
 *          "T":{
 *               "249":"",
 *               "250":["mm"],
 *               "252":["mm"],
 *               "255":"",
 *          }
 *			...
 *     }
 *
 * @param {string}   surfaceCode  : codice superficie del componente principale
 * @param {selector} componentCtx : contesto componente
 *
 * @since 1.0.0
 */
function MixAndMatch(surfaceCode, componentCtx) {
	var componentId = componentCtx.data('component-id');
	var surfaceCtx  = getActiveSurfaceCtx(componentCtx);

	if ( constraints[surfaceCode][componentId].indexOf('mm') >= 0 ) {
		getColorCtx(surfaceCtx, false).hide();
		getColorCtx(surfaceCtx, true).show();
	} else {
		getColorCtx(surfaceCtx).show();
	}
}



/**
 * Gestisce l'incompatibilità tra i componenti non primari della penna.
 * Exception TYPE 1
 *
 * L'oggetto "exceptionsType1" ha la seguente struttura:
 *     exceptionsType1 = {
 *          "100":[
 *              {
 *                 "ms":["Y","Z"],
 *                 "sc":"230",
 *                 "ss":["XXX"]
 *          	},
 *				...
 *          ],
 *          ...
 *     }
 *
 * @param {bool}     init
 * @param {selector} childElement
 *
 * @since 1.0.0
 */
function ET1(init, childElement) {
	if ( !is_defined(init) ) {
		init = false;
	}

	var primaryComponentCtx     = getPrimaryComponentCtx();
	var primaryComponentId      = primaryComponentCtx.data('component-id');
	var primarySurfaceCtx       = getActiveSurfaceCtx(primaryComponentCtx);
	var primarySurfaceCode      = primarySurfaceCtx.data('surface-code');
	var primaryColorCtx         = getActiveColorCtx(primarySurfaceCtx);
	var primaryColorCode        = primaryColorCtx.data('asset-color-code');
	var primaryAlternativeColor = primaryColorCtx.data('alternative-color');
	var currentComponentCtx     = getComponentCtx(childElement);
	var currentComponentId      = currentComponentCtx.data('component-id');

	// Ogni ciclo fa riferimento ad un componente diverso.
	jQuery.each(exceptionsType1, function(key, values) {
		var masterComponentId  = key;
		var masterComponentCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: masterComponentId,
				dataRelation: '='
			}
		]);
		var masterSurfaceCtx   = getActiveSurfaceCtx(masterComponentCtx);
		var masterSurfaceCode  = masterSurfaceCtx.data('surface-code');

		// "values" è un array di oggetti contenenti ciascuno l'incompatibilità tra il componente master e gli altri componenti.
		jQuery.each(values, function(mainIndex, mainElement) {
			var masterSurfaceCodes = mainElement['ms'];
			var slaveComponentId   = mainElement['sc'];
			var slaveSurfaceCodes  = mainElement['ss'];
			var warningMessage     = mainElement['message'];
			var slaveComponentCtx  = getComponentCtxByDataAttribute([
				{
					dataAttribute: 'component-id',
					attributeValue: slaveComponentId,
					dataRelation: '='
				}
			]);

			if ( masterSurfaceCodes.indexOf(masterSurfaceCode.toString()) >= 0 ) {
				if ( !init && currentComponentId == masterComponentId ) {
					showComponentOptionsMessage(currentComponentCtx, warningMessage);
				}
				if ( !init && currentComponentId == primaryComponentId ) {
					resetComponentOptionsMessage();
				}

				var finalSlaveCodes = arrayIntersect([matches[primarySurfaceCode][slaveComponentId], slaveSurfaceCodes]);

				getComponentSurfacesCtx(slaveComponentCtx).each(function(sfrIndex, sfrElement) {
					var surfaceCtx  = jQuery(sfrElement);
					var surfaceCode = surfaceCtx.data('surface-code');

					checkSurfaceCompatibility(finalSlaveCodes, slaveComponentCtx, surfaceCtx);
				});

				var colors                 = [];
				var masterColorCtx         = getColorCtx(masterSurfaceCtx, true);
				var masterColorCode        = masterColorCtx.data('asset-color-code');
				var masterAlternativeColor = masterColorCtx.data('alternative-color');

				colors.push(masterColorCode);

				if ( '' != masterAlternativeColor ) {
					jQuery.merge(colors, masterAlternativeColor.split(','));
				}

				colors.push(primaryColorCode);

				if ( '' != primaryAlternativeColor ) {
					jQuery.merge(colors, primaryAlternativeColor.split(','));
				}

				setAlternativeColor(colors, slaveComponentCtx, null);

				var surfaceCtx = getSurfaceCtxByDataAttribute([
					{
						dataAttribute: 'visible',
						attributeValue: 'true',
						dataRelation: '='
					}
				], true, slaveComponentCtx);

				if ( surfaceCtx.length == 0 ) {
					surfaceCtx = jQuery(getSurfaceCtxByDataAttribute([
						{
							dataAttribute: 'visible',
							attributeValue: 'true',
							dataRelation: '='
						}
					], false, slaveComponentCtx)[0]);

					resetActiveColor(slaveComponentCtx);
					setActiveColor(jQuery(getColorCtx(surfaceCtx)[0]));
				}
			}
		});
	});
}



/**
 * Gestisce il Mix & Match tra i componenti non primari della penna.
 * Exception TYPE 2
 *
 * La presenza della stringa "mm" nella variabile "exceptionsType2" significa che il componente NON supporta il mix & match.
 *
 * L'oggetto "exceptionsType2" ha la seguente struttura:
 *     exceptionsType2 = {
 *          "100":[
 *              {
 *                 "ms":["Y","Z"],
 *                 "sc":"230",
 *                 "mm":"mm"
 *          	},
 *              {
 *                 "ms":["M"],
 *                 "sc":"230",
 *                 "mm":""
 *          	},
 *				...
 *          ],
 *          ...
 *     }
 *
 * @param {bool}     init
 * @param {selector} childElement
 *
 * @since 1.0.0
 */
function ET2(init, childElement) {
	if ( !is_defined(init) ) {
		init = false;
	}

	var primaryComponentCtx = getPrimaryComponentCtx();
	var primaryComponentId  = primaryComponentCtx.data('component-id');
	var primarySurfaceCtx   = getActiveSurfaceCtx(primaryComponentCtx);
	var primaryColorCtx     = getActiveColorCtx(primarySurfaceCtx);
	var primaryColorCode    = primaryColorCtx.data('asset-color-code');
	var currentComponentId  = getComponentCtx(childElement).data('component-id');

	jQuery.each(exceptionsType2, function(key, values) {
		var masterComponentId  = key;
		var masterComponentCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: masterComponentId,
				dataRelation: '='
			}
		]);
		var masterSurfaceCtx   = getActiveSurfaceCtx(masterComponentCtx);
		var masterSurfaceCode  = masterSurfaceCtx.data('surface-code');

		// "values" è un array di oggetti.
		jQuery.each(values, function(mainIndex, mainElement) {
			var masterSurfaceCodes = mainElement['ms'];
			var slaveComponentId   = mainElement['sc'];
			var slaveMixAndMatch   = mainElement['mm'];
			var warningMessage     = mainElement['message'];
			var slaveComponentCtx  = getComponentCtxByDataAttribute([
				{
					dataAttribute: 'component-id',
					attributeValue: slaveComponentId,
					dataRelation: '='
				}
			]);
			var slaveSurfaceCtx    = getActiveSurfaceCtx(slaveComponentCtx);

			if ( masterSurfaceCodes.indexOf(masterSurfaceCode.toString()) >= 0 ) {
				if ( 'mm' == slaveMixAndMatch ) {
					// Non c'è il mix & match.

					if ( !init && currentComponentId == masterComponentId ) {
						showComponentOptionsMessage(warningMessage);
					}

					getActiveColorCtx(slaveSurfaceCtx).removeClass('active');
					getColorCtxByDataAttribute([
						{
							dataAttribute: 'asset-color-code',
							attributeValue: primaryColorCode,
							dataRelation: '!='
						}
					], slaveSurfaceCtx).hide();
					getColorCtxByDataAttribute([
						{
							dataAttribute: 'asset-color-code',
							attributeValue: primaryColorCode,
							dataRelation: '='
						}
					], slaveSurfaceCtx).show().addClass('active');
				} else {
					if ( !init && currentComponentId == masterComponentId ) {
						showComponentOptionsMessage(warningMessage);
					}

					getColorCtx(slaveSurfaceCtx).show();
				}

				if ( !init && currentComponentId == primaryComponentId ) {
					resetComponentOptionsMessage();
				}
			}
		});
	});
}



/**
 * Gestisce comportamenti non standard sul click su un determinato colore di una superficie.
 * Exception TYPE 3
 *
 * L'oggetto "exceptionsType3" ha la seguente struttura:
 *     exceptionsType3 = {
 *        "J72":
 *           {
 *              "action":"message|function|...",
 *              "message":"",
 *              "function":"",
 *              ...
 *           }
 *           ...
 *     }
 *
 * @param  {selector} selectedColorCtx  :
 *
 * @return {bool}
 *
 * @since 1.0.0
 */
function ET3(selectedColorCtx) {
    deferredET3 = jQuery.Deferred();

	var selectedColorCode = selectedColorCtx.attr('data-asset-color-code');
    var et3Colors         = [];
    var inET3Colors       = false;
    var cCode;

    jQuery.each(exceptionsType3, function(key, value) {
        et3Colors.push(key);
    });

    // Nel caso particolare della palette Pantone, "colorCode" potrebbe contenere "PMS" (codice generico) oppure "PMS-102-C" (codice di uno specifico colore).
    jQuery.each(et3Colors, function(index, element) {
        if ( element == colorCode || colorCode.indexOf(element) > -1 ) {
            inET3Colors = true;
            cCode       = element;

            return false;
        }
    });

    if ( inET3Colors ) {
        var action             = exceptionsType3[cCode].action;

        // "selectedColorCtx" corrisponde al tag <li> della lista dei colori.
        var colorsWrapper      = getColorPaletteCtx(selectedColorCtx);
        var colorsWrapperId    = colorsWrapper.attr('data-palette-id');
        var surfaceWrapper     = getSurfaceCtx(selectedColorCtx);
        var surfaceWrapperId   = surfaceWrapper.attr('data-surface-id');
        var surfaceWrapperCode = surfaceWrapper.attr('data-surface-code');
        var panelWrapper       = getComponentCtx(selectedColorCtx);
        var panelWrapperId     = panelWrapper.attr('id');

        switch (action) {
            case 'message':
                // Aggiungo il messaggio in tutte le tab dei componenti:
                //    - se esiste una superficie con codice "surfaceWrapperCode"
                //    - se esiste un colore con codice "selectedColorCode"
				var componentsCtx = getComponentsCtx();

                componentsCtx.each(function(cmpIndex, cmpElement) {
                    var componentCtx = jQuery(cmpElement);
					var surfacesCtx  = getComponentSurfacesCtx(componentCtx);

                    surfacesCtx.each(function(srfIndex, srfElement) {
                        var surfaceCtx  = jQuery(srfElement);
                        var surfaceCode = surfaceCtx.attr('data-surface-code');

                        if ( surfaceCode == surfaceWrapperCode ) {
							var colorsCtx = getColorCtx(surfaceCtx);

                            colorsCtx.each(function(colorIndex, colorElement) {
                               var colorCode = jQuery(colorElement).attr('data-asset-color-code');

                                if ( colorCode == selectedColorCode ) {
                                    var thisMessageWrapper = jQuery('.color-message', surfaceCtx);

                                    if ( jQuery('p[data-asset-color-code="' + colorCode + '"]', thisMessageWrapper).length == 0 ) {
                                        var message = jQuery('<p data-asset-color-code="' + colorCode + '">' + exceptionsType3[colorCode].message + '</p>');

                                        thisMessageWrapper.append(message);
                                    }
                                }
                            });
                        }
                    });
                });

                var messageWrapper = jQuery('.color-message', surfaceWrapper);

                jQuery('p[data-asset-color-code!="' + colorCode + '"]', messageWrapper).removeClass('active');
                jQuery('p[data-asset-color-code="' + colorCode + '"]', messageWrapper).addClass('active');
                deferredET3.resolve();
                break;
            case 'function':
                switch (exceptionsType3[cCode].function) {
                    case 'show_pms_colors':
                        ShowPMSColors(panelWrapperId, surfaceWrapperId, colorsWrapperId, selectedColorCode, deferredET3);
                        break;
                    default:
                        deferredET3.resolve();
                        break;
                }
                break;
            default:
                // Do nothing.
                return false;
        }
    } else {
        var panelWrapper = getComponentCtx(selectedColorCtx);

        jQuery('.color-message p', panelWrapper).removeClass('active');
        deferredET3Output = {};
        deferredET3.resolve();
    }

    return deferredET3.promise();
}



/**
 * La selezione di una data superficie di un dato componente scatena l'esecuzione di una funzione.
 * Exception TYPE 4
 *
 * L'oggetto "exceptionsType4" ha la seguente struttura:
 *     exceptionsType4 = {
 *          "100":[
 *              {
 *                 "ms":["Y","Z"],
 *                 "function":"",
 *                 "function_args":""
 *          	},
 *				...
 *          ],
 *          ...
 *     }
 *
 * @since 1.0.0
 */
function ET4() {
	jQuery.each(exceptionsType4, function(key, values) {
		var masterComponentId  = key;
		var masterComponentCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: masterComponentId,
				dataRelation: '='
			}
		]);
		var masterSurfaceCtx   = getActiveSurfaceCtx(masterComponentCtx);
		var masterSurfaceCode  = masterSurfaceCtx.data('surface-code');

		// "values" è un array di oggetti.
		jQuery.each(values, function(index, element) {
			var masterSurfaceCodes = element['ms'];

			if ( masterSurfaceCodes.indexOf(masterSurfaceCode.toString()) >= 0 ) {
				var functionName = element['function'];
				// "functionArgs" è un array con gli argomenti da passare alla funzione.
				// La tipologia degli argomenti è strettamente legata alla funzione di riferimento.
				var functionArgs = element['function_args'].split(',');

				switch ( functionName ) {
					case 'move_print_area':
						// "functionArgs" è un array di coppie {printAreaCode}|{topOffset}.
						jQuery.each(functionArgs, function(index, element) {
							var args          = element.split('|');
							var printAreaCode = args[0];
							var topOffset     = parseFloat(args[1]);

							MovePrintArea(printAreaCode, topOffset);
						});
						break;
				}
			}
		});
	});
}



/**
 * Gestisce la selezione dei colori Pantone.
 *
 * @param {string}   panelWrapperId   : attributo "id" del panel corrente
 * @param {int}      surfaceWarpperId : attributo "data-surface-id" della superficie corrente
 * @param {int}      colorsWrapperId  : attributo "data-palette-id" della lista dei colori corrente
 * @param {string}   colorCode        : codice colore selezionato
 * @param {deferred} deferredET3      : deffered
 *
 * @since 1.0.0
 */
function ShowPMSColors(panelWrapperId, surfaceWrapperId, colorsWrapperId, colorCode, deferredET3) {
    var dataObj = {
        panelWrapperId: panelWrapperId,
        surfaceWrapperId: surfaceWrapperId,
        colorsWrapperId: colorsWrapperId,
        colorCode: colorCode
    };

    jQuery('#pms').attr('data-object', JSON.stringify(dataObj));

	if ( pms_code != colorCode ) {
        jQuery('.pms-list li.active').removeClass('active');
        jQuery('.pms-list li .selection span[data-asset-color-code="' + colorCode + '"]').closest('li').addClass('active');
    }

    jQuery('#pms').modal('show');
    jQuery('.pms-list .selection span').tooltip();
}



/**
 * Salva il colore corrente prima che venga reso attivo quello selezionato.
 * Serve per poter tornare al colore precedente nel caso venga chiusa la modal dei colori Pantone senza aver effettuato alcuna selezione.
 *
 * @param {string} panelWrapperId       : attributo "id" del panel corrente
 * @param {int}    surfaceWrapperId     : attributo "data-surface-id" della superficie corrente
 * @param {string} surfaceCode          : attributo "data-surface-code" della superficie corrente
 * @param {int}    colorsWrapperId      : attributo "data-palette-id" della lista dei colori corrente
 * @param {string} colorCode            : codice colore corrente
 * @param {string} alternativeColorCode : codice colore alternativo del colore corrente
 *
 * @since 1.0.0
 */
function saveSelectedColor(panelWrapperId, surfaceWrapperId, surfaceCode, colorsWrapperId, colorCode, alternativeColorCode) {
    // "undoSelectedColors" è un oggetto JSON che ha come indice primario l'ID del panello corrispondente ad un dato componente;
    // il valore è un oggetto JSON con:
	//    - l'ID della superficie
	//    - il codice della superficie
	//    - l'ID della palette di colori associata a quella superficie
	//    - il codice del colore all'interno della palette
	//    - il codice del corrispondente colore alternativo
    undoSelectedColors[panelWrapperId] = {
        surfaceWrapperId: surfaceWrapperId,
        surfaceCode: surfaceCode,
        colorsWrapperId: colorsWrapperId,
        colorCode: colorCode,
        alternativeColorCode: alternativeColorCode
    };
}



/**
 * Aggiorna le aree di stampa in relazione alle superfici ed ai colori selezionati.
 *
 * @since 1.1.0
 */
function updatePrintAreas() {
	var componentsCtx = getComponentsCtx();

	componentsCtx.each(function(index, element) {
		var componentCtx       = jQuery(element);
		var componentType      = componentCtx.data('component-type');
		var componentId        = componentCtx.data('component-id');
		var surfaceCtx         = getActiveSurfaceCtx(componentCtx);
		var surfaceCode        = surfaceCtx.data('surface-code');
		var colorCtx           = getActiveColorCtx(surfaceCtx);
		var colorCode          = colorCtx.data('asset-color-code');
		var alternativeColor   = colorCtx.data('alternative-color');
		var primaryCtx         = getPrimaryComponentCtx();
		var primarySurfaceCode = getActiveSurfaceCtx(primaryCtx).data('surface-code');

		updateComponentPrintAreas(componentId, surfaceCode, primarySurfaceCode);
	});
}



/**
 * Mostra/Nasconde le aree di stampa in relazione alla superficie selezionata per un dato componente e per il componente principale della penna.
 *
 * @param {string} componentId        : ID del componente
 * @param {string} surfaceCode        : codice superficie del componente
 * @param {string} primarySurfaceCode : codice superficie del componente principale
 *
 * @since 1.0.0
 */
function updateComponentPrintAreas(componentId, surfaceCode, primarySurfaceCode) {
	var printAreasDropdown = jQuery('.selectpicker.nav-pills-printareas-tab-dropdown', getImprintMainCtx());

	if ( printAreasAdvancedSettings.length == 0 ) {
		// Analizzo il menu di selezione delle aree di stampa.
		var printAreaTabsCtx = getPrintAreaTabCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: componentId,
				dataRelation: '='
			}
		]);

		printAreaTabsCtx.each(function(index, element) {
			var surfaceCodes = jQuery(element).data('surface-codes');

			if ( is_defined(surfaceCodes) ) {
				surfaceCodes = surfaceCodes.split(',');

				showHideElement(jQuery(element), surfaceCode, primarySurfaceCode, surfaceCodes);
			}
		});


		// Analizzo la select di selezione delle aree di stampa (versione smartphone).
		if ( printAreasDropdown.length > 0 ) {
			var printAreaOptionsLinkCtx = getPrintAreaTabDropdownCtxByDataAttribute([
				{
					dataAttribute: 'component-id',
					attributeValue: componentId,
					dataRelation: '='
				}
			]);

			printAreaOptionsLinkCtx.each(function(index, element) {
				var surfaceCodes = jQuery(element).data('surface-codes');

				if ( is_defined(surfaceCodes) ) {
					surfaceCodes = surfaceCodes.split(',');

					enableDisableElement(jQuery(element), surfaceCode, primarySurfaceCode, surfaceCodes);
				}
			});
		}


		// Analizzo le aree di stampa sulle anteprime della penna.
		jQuery('.pen-preview .print-area[data-component-id="' + componentId + '"]').each(function(index, element) {
			var surfaceCodes = jQuery(element).data('surface-codes');

			if ( is_defined(surfaceCodes) ) {
				surfaceCodes = surfaceCodes.split(',');

				if ( jQuery.inArray(surfaceCode, surfaceCodes) > -1 || jQuery.inArray(primarySurfaceCode, surfaceCodes) > -1 ) {
					jQuery(element).attr('data-visible', true).show();
				} else {
					jQuery(element).attr('data-visible', false).hide();
				}
			}
		});
	} else {
		// "printAreaAdvancedSettings" è un oggetto così strutturato:
		//    {
		//       areaId: {
		//          componentId: [surfaces codes],
		//          ...
		//       },
		//       ...
		//    }
		//
		// esempio:
		//   {
		//      1011: {
		//         836: "T Curve,P Curve"
		//      },
		//      2198: {
		//         834: "M,R",
		//         836: "T Curve,P Curve,P Flat,T Flat"
		//      },
		//      2337: {
		//         836: "T Flat,P Flat"
		//      },
		//      2340: {
		//         836: "S"
		//      }
		//   }

		jQuery.each(printAreasAdvancedSettings, function(areaId, rules) {
			var visible          = true;
			var printAreaTabsCtx = getPrintAreaTabCtxByDataAttribute([
					{
						dataAttribute: 'area-id',
						attributeValue: areaId,
						dataRelation: '='
					}
				]);

			if ( printAreasDropdown.length > 0 ) {
				var printAreaOptionsLinkCtx = getPrintAreaTabDropdownCtxByDataAttribute([
					{
						dataAttribute: 'area-id',
						attributeValue: areaId,
						dataRelation: '='
					}
				]);
			}

			jQuery.each(rules, function(componentId, surfaces) {
				var componentCtx        = getComponentCtxByDataAttribute([
					{
						dataAttribute: 'component-id',
						attributeValue: componentId,
						dataRelation: '='
					}
				]);
				var selectedSurfaceCode = getActiveSurfaceCtx(componentCtx).attr('data-surface-code');

				surfaces                = surfaces.split(',');

				if ( jQuery.inArray(selectedSurfaceCode, surfaces) == -1 ) {
					visible = false;
				}
			});

			if ( visible ) {
				printAreaTabsCtx.attr('data-visible', true).show();

				if ( printAreasDropdown.length > 0 ) {
					printAreaOptionsLinkCtx.attr('data-visible', true).prop('disabled', false);
				}

				jQuery('.pen-preview .print-area[data-area-id="' + areaId + '"]').attr('data-visible', true).show();
			} else {
				printAreaTabsCtx.attr('data-visible', false).hide();

				if ( printAreasDropdown.length > 0 ) {
					printAreaOptionsLinkCtx.attr('data-visible', false).prop('disabled', true);
				}

				jQuery('.pen-preview .print-area[data-area-id="' + areaId + '"]').attr('data-visible', false).hide();
			}
		});
	}

	var printAreaActiveTabCtx = getActivePrintAreaTabCtx();
	var printAreaId           = printAreaActiveTabCtx.data('area-id');

	if ( printAreaActiveTabCtx.length > 0 && printAreaActiveTabCtx.attr('data-visible') == 'false' ) {
		getPrintAreaTabCtxByDataAttribute([
			{
				dataAttribute: 'visible',
				attributeValue: 'true',
				dataRelation: '='
			}
		]).first().trigger('click');
	} else {
		printAreaActiveTabCtx.trigger('click');
	}

	if ( printAreasDropdown.length > 0 ) {
		printAreasDropdown.selectpicker('refresh');
		printAreasDropdown.selectpicker(printAreasSelectPickerOptions);

		updatePrintAreasCompleted();
	}

	jQuery('.pen-preview .print-area[data-area-id="' + printAreaId + '"]').addClass('active');
}

function showHideElement(element, needle, mainNeedle, haystack) {
	if ( jQuery.inArray(needle, haystack) > -1
		 || ( jQuery.inArray(mainNeedle, haystack) > -1
			  && needle.indexOf(dummy_surface_code) == -1 ) ) {
		element.attr('data-visible', true).show();
	} else {
		element.attr('data-visible', false).hide();
	}
}


function enableDisableElement(element, needle, mainNeedle, haystack) {
	if ( jQuery.inArray(needle, haystack) > -1
		 || ( jQuery.inArray(mainNeedle, haystack) > -1
			  && needle.indexOf(dummy_surface_code) == -1 ) ) {
		element.attr('data-visible', true).prop('disabled', false);
	} else {
		element.attr('data-visible', false).prop('disabled', true);
	}
}

function updatePrintAreasCompleted() {
	var printAreasDropdown = jQuery('.selectpicker.nav-pills-printareas-tab-dropdown', getImprintMainCtx());

	if ( printAreasDropdown.length > 0 ) {
		if ( null == printAreasDropdown.selectpicker('val') ) {
			var availableOptionCtx = getPrintAreaFirstAvailableOptionCtx();

			printAreasDropdown.selectpicker('val', availableOptionCtx.attr('value'));
		}

		printAreasDropdown.selectpicker('refresh');
		printAreasDropdown.selectpicker(printAreasSelectPickerOptions);

		printAreasDropdown.trigger('change');
	}
}



/**
 * Gestisce i colori dell'inchiosto e i diametri a seconda del sistema di scrittura selezionato.
 *
 * @since 1.0.0
 */
function updateWritingSystemOptions() {
	var refillOptionsCtx  = getRefillOptionsCtx();
	var selectedRefillCtx = getSelectedRefillCtx(refillOptionsCtx);
	var selectedRefillId  = selectedRefillCtx.data('refill-id');
	var refillsCtx        = getRefillCtx(0, refillOptionsCtx);

	refillsCtx.each(function(index, element) {
		var refillParentCtx = getRefillContainerCtx(jQuery(element), 'parent');
		var refillId        = jQuery(element).data('refill-id');
		var colorOptions    = getInkColorOptionsCtx(refillOptionsCtx, refillId);
		var diameterOptions = getRefillDiameterOptionsCtx(refillOptionsCtx);
		var option          = 0;

		if ( refillId == selectedRefillId ) {
			refillParentCtx.addClass('active');
		} else {
			refillParentCtx.removeClass('active');
		}

		colorOptions.each(function(index, element) {
			var colorsCtx = jQuery(element);

			if ( colorsCtx.data('refill-id') == refillId ) {
				option = getActiveInkColorCtx(colorsCtx).data('option');
			}
		});

		diameterOptions.each(function(index, element) {
			var diameterCtx = jQuery(element);

			if ( diameterCtx.data('refill-id') == refillId ) {
				getRefillDiameterOptionCtx(option, '!=', diameterCtx).hide();
				getRefillDiameterOptionCtx(option, '=', diameterCtx).show();
			}
		});
	});

}



/**
 * Applica le regole relative ai sistemi di scrittura.
 *
 * @param {int}    componentId : ID del componente selezionato
 * @param {string} surfaceCode : codice superficie
 *
 * @since 1.0.0
 */
function writingSystemAdvancedSettings(componentId, surfaceCode) {
	if ( refillsAdvancedSettings.length > 0 && is_defined(refillsAdvancedSettings[componentId]) ) {
		var rules = refillsAdvancedSettings[componentId];
		var ctx   = getRefillOptionsCtx();

		jQuery.each(rules, function(index, element) {
			if ( jQuery.inArray(surfaceCode, element.surfaces) > -1 ) {
				var refillId           = element.refill_id;
				var refillColor        = element.refill_color;
				var refillDiameter     = element.refill_diameter;
				// Radio button relativo al tipo di refill,
				var refillCtrl         = getRefillCtx(refillId);
				// Selettore del colore dell'inchiostro.
				var refillColorCtrl    = getInkColorCtxByDataAttribute(refillId, refillColor);
				var option             = refillColorCtrl.data('option');
				var refillDiametersCtx = getRefillDiameterOptionCtx(option, '=', getRefillDiameterOptionsCtx(ctx, refillId));
				// Radio button relativo al diametro del refill.
				var refillDiameterCtrl = getRefillDiameterCtx(refillDiameter, refillDiametersCtx);

				refillCtrl.trigger('click');
				refillColorCtrl.trigger('click');
				refillDiameterCtrl.trigger('click');
			}
		});
	}
}



/**
 * Mostra/Nasconde le palette di colori per il testo delle aree di stampa.
 *
 * @since 1.0.0
 */
function updateTextColorPalette() {
	var printAreaTabsCtx = getPrintAreaTabsCtx();

	jQuery('.ancestor-tab', printAreaTabsCtx).each(function(ancestorTabIndex, ancestorTabElement) {
		var ancestorTabCtx  = jQuery(ancestorTabElement);
		var componentId     = ancestorTabCtx.data('component-id');
		var componentCtx    = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: componentId,
				dataRelation: '='
			}
		]);
		var surfaceCtx      = getActiveSurfaceCtx(componentCtx);
		var surfaceCode     = surfaceCtx.data('surface-code');
		var printAreaTabCtx = getPrintAreaTabCtxByAttribute([
			{
				attributeType: 'id',
				attributeValue: 'text-',
				dataRelation: '^='
			}
		], ancestorTabCtx);

		printAreaTabCtx.each(function(parentTabIndex, parentTabElement) {
			var parentTabCtx = jQuery(parentTabElement);

			jQuery('.colors-list', parentTabCtx).each(function(index, element) {
				var that           = jQuery(element);
				var surfaceCodes   = that.data('surface-codes').split(',');
				var activeColorCtx = jQuery('li.active', that);
				var activeColor    = jQuery('.selection span', activeColorCtx);
				var colorHexCode   = activeColor.attr('data-color-hexcode');
				var colorLabel     = is_defined(activeColor.attr('data-original-title')) ? activeColor.attr('data-original-title') : activeColor.attr('title');

				if ( jQuery.inArray(surfaceCode, surfaceCodes) > -1 ) {
					that.attr('data-visible', true);

					jQuery('.font-color', parentTabCtx).attr('data-color-hexcode', colorHexCode).attr('data-color-label', colorLabel);
				} else {
					that.attr('data-visible', false);
				}
			});
		});

	});

}



/**
 * Gestisce l'eventuale presenza dello switch "Remove option".
 *
 * @since 1.1.0
 */
function removeOptionHandler() {
	var componentsCtx = getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-type',
			attributeValue: 'optional',
			dataRelation: '='
		}
	]);

	componentsCtx.each(function(index, element) {
		var componentCtx  = jQuery(element);
		var surfaceCtx    = getActiveSurfaceCtx(componentCtx);
		var surfaceCode   = surfaceCtx.data('surface-code');
		var switchControl = getRemoveOptionSwitch(componentCtx);
		var surfacesCtx   = getComponentSurfacesCtx(componentCtx, true);

		if ( remove_option_code == surfaceCode && !switchControl.prop('checked') ) {
			switchControl.prop('checked', true);

			jQuery.each(surfacesCtx, function(index, element) {
				if (!jQuery(element).hasClass('not-available-surface')) {
					jQuery(element).addClass('disabled');
				}
			});
		}

		if ( remove_option_code != surfaceCode ) {
			switchControl.prop('checked', false);
		}
	});
}



/**
 * Riorganizza le colonne contenenti le opzioni dei componenti (refill compresi).
 *
 * @since 1.1.0
 */
function reorderComponentsOptions() {
	var primaryComponentCtx = getPrimaryComponentCtx();
	var primarySurfacesCtx  = getComponentSurfacesCtx(primaryComponentCtx);
	var componentsCtx       = getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-type',
			attributeValue: 'primary',
			dataRelation: '!='
		}]);

	if ( primarySurfacesCtx.length == 1 ) {
		primarySurfacesCtx.closest('.surface-wrapper').removeClass('col-lg-6');
	}

	componentsCtx.each(function(index, element) {
		var componentCtx       = jQuery(element);
		var visibleSurfacesCtx = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'visible',
				attributeValue: 'true',
				dataRelation: '='
			},
			{
				dataAttribute: 'surface-code',
				attributeValue: remove_option_code,
				dataRelation: '!='
			}], false, componentCtx);

		if ( visibleSurfacesCtx.length > 1 ) {
			visibleSurfacesCtx.each(function(index, element) {
				jQuery(element).closest('.surface-wrapper').addClass('col-lg-6');
			});
		} else {
			visibleSurfacesCtx.each(function(index, element) {
				jQuery(element).closest('.surface-wrapper').removeClass('col-lg-6');
			});
		}
	});


	var cssClass      = 'last';
	var componentsCtx = getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-type',
			attributeValue: 'null',
			dataRelation: '!='
		},
		{
			dataAttribute: 'remove-option',
			attributeValue: 'false',
			dataRelation: '='
		}]);

	componentsCtx.each(function(index, element) {
		var componentCtx       = jQuery(element);
		var visibleSurfacesCtx = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'visible',
				attributeValue: 'true',
				dataRelation: '='
			}], false, componentCtx);

		jQuery('.' + cssClass, visibleSurfacesCtx).removeClass(cssClass);

		if ( visibleSurfacesCtx.length % 2 === 0 ) {
			visibleSurfacesCtx = jQuery(visibleSurfacesCtx.slice(-2));
		} else {
			visibleSurfacesCtx = jQuery(visibleSurfacesCtx[visibleSurfacesCtx.length - 1]);
		}

		visibleSurfacesCtx.each(function(srfIndex, srfElement) {
			jQuery(srfElement).closest('.surface-wrapper').addClass(cssClass);
		});
	});

	var writingSystemsCtx = getRefillContainerCtx();

	jQuery('.' + cssClass, writingSystemsCtx).removeClass(cssClass);

	if ( writingSystemsCtx.length % 2 === 0 ) {
		writingSystemsCtx = jQuery(writingSystemsCtx.slice(-2));
	} else {
		writingSystemsCtx = jQuery(writingSystemsCtx[writingSystemsCtx.length - 1]);
	}

	writingSystemsCtx.each(function(wsIndex, wsElement) {
		jQuery(wsElement).closest('.writing-system-wrapper').addClass(cssClass);
	});
}



/**
 * Mostra il messaggio di avviso.
 *
 * @param {selector} ctx     : contesto componente
 * @param {string}   message : testo del messaggio
 *
 * @since 1.1.0
 */
function showComponentOptionsMessage(ctx, message) {
	jQuery('.warning-message-container', ctx).html(message);

}



/**
 * Resetta tutti i messaggi di avviso.
 *
 * @since 1.1.0
 */
function resetComponentOptionsMessage() {
	jQuery('.warning-message-container').html('');
}



/**
 * Gestisce la chiusura del pannello relativo ad un componente.
 *
 * @since 1.1.0
 */
function closeActivePanel() {
	if ( jQuery('.component-options.active').hasClass('refill-options') ) {
		jQuery('.refill-options .options-content').animate({
			scrollLeft: 0
		}, 245);
	}

	jQuery('.component-options.active').removeClass('active');
	jQuery('.component-selector.active').removeClass('active');
	jQuery('.component-selector.disabled').removeClass('disabled');
	jQuery('.component-options-backdrop').fadeOut(200);
}



/**
 * Gestisce l'apertura del pannello relativo ad un componente.
 *
 * @param {selector} componentSelector :
 *
 * @since 1.1.0
 */
function openPanel(componentSelector) {
	var ctx           = componentSelector.closest('.config-controls');
	var componentSlug = componentSelector.data('component-slug');

	componentSelector.addClass('active');
	ctx.addClass('active');
	jQuery('.component-selector:not(.active)', ctx).addClass('disabled');
	jQuery('.component-options-backdrop').fadeIn(200);

	getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-slug',
			attributeValue: componentSlug,
			dataRelation: '='
		}
	], false).addClass('active');
}



/**
 * Mostra/Nasconde i QR code.
 *
 * @since 2.0.0
 */
function updateQRCodes() {
	var printAreaTabsCtx = getPrintAreaTabsCtx();

	jQuery('.ancestor-tab', printAreaTabsCtx).each(function(ancestorTabIndex, ancestorTabElement) {
		var ancestorTabCtx  = jQuery(ancestorTabElement);
		var componentId     = ancestorTabCtx.data('component-id');
		var componentCtx    = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: componentId,
				dataRelation: '='
			}
		]);
		var surfaceCtx      = getActiveSurfaceCtx(componentCtx);
		var surfaceCode     = surfaceCtx.data('surface-code');
		var printAreaTabCtx = getPrintAreaTabCtxByAttribute([
			{
				attributeType: 'id',
				attributeValue: 'qrcode-',
				dataRelation: '^='
			}
		], ancestorTabCtx);

		printAreaTabCtx.each(function(parentTabIndex, parentTabElement) {
			var parentTabCtx = jQuery(parentTabElement);

			jQuery('.qrcodes-grid .item', parentTabCtx).each(function(index, element) {
				var that         = jQuery(element);
				var surfaceCodes = that.data('surface-codes').split(',');

				if ( jQuery.inArray(surfaceCode, surfaceCodes) > -1 ) {
					that.attr('data-visible', false).hide();
				} else {
					that.attr('data-visible', true).show();
				}
			});
		});

	});

}
